import css from 'styled-jsx/css';

const staticStyles = css`
  @import 'src/common/styling/_mixins-scss/screen-size';

  .CreateAccountForm {
    width: 500px;

    &__open-price-wrapper {
      padding: 24px;
      margin-bottom: 24px;
      display: flex;
      align-items: center;
      gap: 16px;
      margin-top: 12px;
      border-radius: 8px;
      background: rgba(242, 178, 51, 0.1);

      &__icon-wrapper {
        color: #f2b233;
      }

      span {
        font-size: 14px;
        font-weight: 500;
      }
    }

    .formError {
      display: none;
    }

    @media only screen and (max-height: 420px) {
      padding-bottom: 30px;
    }

    @include respond-to(sm) {
      min-width: 100%;
      max-width: 100%;
    }
  }
`;

export { staticStyles };
